<template>
   <div v-if="open" class="modal-background" @click="$emit('close', 'background')">
       <div class="modal-box" @click.stop>
            <div v-if="$slots['header']" class="header">
                <slot name="header"/>

                <i class="fas fa-times close-button clickable" @click="$emit('close')"/>
            </div>

            <div v-if="$slots['body']" class="body">
                <slot name="body"/>
            </div>

            <div v-if="$slots['footer']" class="footer">
                <slot name="footer"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['open'],
    
}
</script>

<style lang="sass" scoped>
    @import "../assets/colors";

    .modal-background
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #0009
        display: flex;
        flex-direction: column;
        justify-content: flex-start
        align-items: center
        z-index: 10
        

        .modal-box
            background-color: darken($dark-bg, 5%);
            border: 1px solid $border-medium;
            border-radius: 5px;
            width: 50%;
            box-shadow: $card-shadow;
            margin-top: 10%;
            @media only screen and (max-width: 720px) 
                width: 80%;

    .header
        position: relative;
        padding: 5px;
        vertical-align: middle;

        i
            position: absolute;
            right: 3px;
            top: 3px;
            padding: 5px;
    

    .footer
        display: flex
        justify-content: center
        padding: 10px 10px
    
</style>